import dynamic from 'next/dynamic';
import { createClient } from 'contentful';
import { Seo } from '@/components/Seo';
import { SEO_DATA } from '@/utils/seoConstants/blog-page';
import { CONTENTFUL_ARTICLES_ID } from '@/utils/constants';
import Breadcrumbs from '@/containers/Blog/components/Breadcrumbs/Breadrumbs';

const NotFound = dynamic(
  () => import(`@/containers/Blog/components/NotFound/NotFound`),
);
const ArticlePage = dynamic(
  () => import(`@/containers/Blog/components/ArticlePage/ArticlePage`),
);

const Article = ({ article, slug }: any) => {
  const { title, description, preview } = article.fields;
  return !title ? (
    <NotFound />
  ) : (
    <>
      <Breadcrumbs name={title} id={slug} />
      <ArticlePage article={article} />
      <Seo
        {...SEO_DATA}
        customOGImage={preview?.fields?.file?.url}
        customTitle={title}
        customDescription={description}
        type={`article`}
      />
    </>
  );
};

export async function getServerSideProps(context: any) {
  const slug = context.params.id;
  const client = createClient({
    space: process.env.CONTENTFUL_SPACE || ``,
    accessToken: process.env.CONTENTFUL_ACCESS_TOKEN || ``,
  });
  const articles = await client.getEntries({
    content_type: CONTENTFUL_ARTICLES_ID,
    'fields.slug': slug,
    limit: 1,
  });

  return {
    props: { article: articles?.items[0] || { fields: {} }, slug },
  };
}

export default Article;
